var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_68_1160)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.308779 5.27736C0.707883 4.89561 1.34089 4.90967 1.72264 5.30878L12 16.0533L22.2774 5.30878C22.6591 4.90967 23.2921 4.89561 23.6912 5.27736C24.0903 5.65911 24.1044 6.29212 23.7226 6.69122L12.7226 18.1912C12.534 18.3885 12.2729 18.5 12 18.5C11.7271 18.5 11.466 18.3885 11.2774 18.1912L0.27736 6.69122C-0.104392 6.29212 -0.0903251 5.65911 0.308779 5.27736Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_68_1160"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/caret-down.0b02ede34de8c4508304c1a3efbefee4.svg";
export { ForwardRef as ReactComponent };